export enum SustainabilitySections {
	Biodiversity = 1,
	Community = 2,
	PeoplePractices = 3,
	Water = 4,
	EnergyAndClimate = 5,
	WasteAndPlastic = 6,
	Procurement = 7,
	CultureAndHeritage = 8,
	CredibleCommunication = 9,
	Accountability = 10,
	Certifications = 11
}
